import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=5d8282e5&scoped=true"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"
import style0 from "./Room.vue?vue&type=style&index=0&id=5d8282e5&prod&lang=scss&scoped=true"
import style1 from "./Room.vue?vue&type=style&index=1&id=5d8282e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8282e5",
  null
  
)

export default component.exports